import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, switchMap } from 'rxjs';
import { getUserData, userData } from './user.actions';
import { UserService } from 'src/app/services/user.service';
import { UserDetails } from 'src/app/components/login/user.model';

@Injectable()
export class FetchUserDataEffect {
  constructor(private actions$: Actions, private userService: UserService) {}

  fetchUserData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getUserData),
      switchMap((action) => {
        // console.log('user effect actions', action);
        return this.userService.userDataEffect();
      }),
      map((res) => {
        // console.log('user effect data', res);
        return userData({ user: res as UserDetails });
      })
    );
  });
}
